import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    selectedField: undefined,
};

export default createReducer(initial, {
    [actions.setSelectedField]: (state, action) => {
        return { ...state, selectedField: action.payload };
    },
});
